import { RestCallsService } from './../rest-calls.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, LoadingController } from '@ionic/angular';
import { AuthenticationService } from '../services/authentication.service';

@Component({
    selector: 'user.modal.page',
    templateUrl: './user.modal.page.html',
    styleUrls: ['./user.modal.page.scss'],
})
export class UserModalPage implements OnInit {
    users = [];
    loader: any;
    loading = false;
    hasmoreData = true;
    type = -1;
    formData: any;
    userId: any;

    constructor(
        private modalController: ModalController,
        private navParams: NavParams,
        private loadingCtrl: LoadingController,
        private apiService: RestCallsService,
        public service: AuthenticationService,
    ) { }

    ngOnInit() {
        this.service.getLoggedInUser().then((res: any) => {
            this.userId = res.data.userId;
            this.getData();
        });
        console.table(this.navParams);
    }

    changeSelected(user) {
        console.log(this.users);
    }
    async presentLoading(msg) {
        this.loader = await this.loadingCtrl.create({
            message: msg
        });
        console.log(1);
        return await this.loader.present();
    }
    // closeModal() {
    //   this.modalController.dismiss(this.customer);
    // }
    done() {
        const selectedContacts = [];
        for (let i = 0; i < this.users.length; i++) {
            if (this.users[i].selected) {
                selectedContacts.push(this.users[i]);
            }
        }
        if (selectedContacts.length <= 0) {
            alert('Select users');
        } else {
            this.modalController.dismiss({
                selectedContacts: selectedContacts,
                // index: this.index
            });
        }
    }
    back() {
        this.modalController.dismiss(null);
    }

    getData() {
        this.formData = {
            'userId': this.userId,
        };
        this.loading = true;
        this.apiService.getUsers(this.formData).subscribe((res: any) => {
            console.log(res);
            if (res.data.length <= 0) {
                this.hasmoreData = false;
                this.loading = false;
            }
            this.loading = false;
            for (let i = 0; i < res.data.length; i++) {
                this.users.push({
                    'id': res.data[i].id,
                    'name': res.data[i].name,
                    'selected': false,
                });
            }
        });
    }

    doRefresh(event) {
        event.target.complete();
        this.users = [];
        this.getData();
    }


    getCustomerType(type) {
        switch (type) {
            case 1:
                return 'Domestic';
            case 2:
                return 'Gym';
            case 3:
                return 'Government';
            case 4:
                return 'Real Estate';
            case 5:
                return 'Corporate';
        }
    }

    getUserTypeString(value) {
        switch (value) {
            case 1:
                return 'Admin';
            case 2:
                return 'Distributor';
            case 3:
                return 'Dealer';
            case 4:
                return 'Sales Head';
            case 5:
                return 'Sales Rep';
        }
    }
}
